import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import { FormControl, Modal } from "react-bootstrap";

export const FormContainer = styled("div")`
  #root_ticker {
    width: 190px;
  }

  #root_mapTo {
    width: 160px;
  }

  // Chromium on Windows hides the option labels of a native select wider than its popup.
  #root_type {
    width: 320px;
  }
`;

export const WarningContainer = styled.div`
  padding: 12px 20px;
  margin: 20px 0 20px 0;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
  border-radius: 4px;
  width: 100%;
  font-size: 14px;
  font-weight: bold;
`;

export const ButtonContainer = styled.div<{ alignRight?: boolean }>`
  display: flex;
  justify-content: ${props => (props.alignRight ? "flex-end" : "flex-start")};
  margin: 0 0 0.5rem 0;
`;

export const StyledInfoIcon = styled.i`
  cursor: pointer;
  margin-left: 5px;
`;

export const StyledReactTooltip = styled(ReactTooltip)`
  text-transform: none;
  border-radius: 5px;
`;

export const StyledModal = styled(Modal)<{
  maxWidth?: string;
  overflowVisible?: boolean;
}>`
  .modal-dialog-scrollable .modal-content {
    overflow: ${props => (props.overflowVisible ? "visible" : "hidden")};
  }
  .modal-dialog-scrollable .modal-body {
    overflow-y: ${props => (props.overflowVisible ? "visible" : "auto")};
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: ${props => (props.maxWidth ? props.maxWidth : "740px")};
    }
  }
`;

export const ModalHeader = styled(Modal.Header)`
  display: block;
  width: 100%;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
`;

export const StyledFormControl = styled(FormControl)`
  font-size: 13px;
`;
